import { enabledByParams, RequestParams, RequestQueryOptions } from '@approvalmax/data';
import { useGet } from 'shared/data';

import { integrationApiPaths } from '../paths';
import { GetItems } from './useGetItems.types';

/**
 * This endpoint responds with XeroItems, but it's naming does not show this.
 */
export const useGetItems = (params?: RequestParams<GetItems>, queryOptions?: RequestQueryOptions<GetItems>) => {
    return useGet(integrationApiPaths.getItems, {
        params,
        queryOptions: {
            enabled: enabledByParams<GetItems['params']['query']>(
                {
                    requestId: params?.query?.requestId,
                    companyId: params?.query?.companyId,
                    ruleType: params?.query?.ruleType,
                },
                queryOptions
            ),
            ...queryOptions,
        },
        apiVersion: 'v1',
        method: 'post',
        mapToCamelCase: true,
    });
};
